import $ from 'jquery';

const $body = $('body');

const Checkout = {
    init() {
        $body.on('change', '#billing_street', () => this.handleAddress());
        $body.on('change', '#billing_country', () => this.handlePostcodeApi());

        this.handlePostcodeApi();
    },

    handleAddress() {
        const $addressField = $('#billing_address_1');
        const $street = $('#billing_street');
        const $number = $('#billing_houseno');

        const address = `${$street.val()} ${$number.val()}`;

        $addressField.val(address);
    },

    handlePostcodeApi() {
        const script = $('script[src="https://cdn.postcodeapi.nu/widget-v1.1.js"]');

        if ($('#billing_country').val() !== 'NL') {
            script.remove();

            $('#billing_street').attr('readonly', false);
            $('#billing_street_field').addClass('readonly');
            $('#billing_city').attr('readonly', false);
            $('#billing_city_field').addClass('readonly');
        } else if (!script.length) {
            $('<script>').attr('src', 'https://cdn.postcodeapi.nu/widget-v1.1.js').appendTo('body');
        }
    },
};

export default Checkout;
